import { classNames } from 'libs/react';
import { React } from 'libs/react';
import './SidePanel.scss';
/**
 * @component SidePanel
 * @since 1.0.0
 */
export function SidePanel(props) {
    const { style, active } = Object.assign({ style: 'normal', active: false }, props);
    const className = classNames('side-panel', 'side-panel--' + style, { 'side-panel--is-active': active }, props.className);
    return React.createElement("div", { className: className }, props.children);
}
